import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Centralised, professionally-styled Markdown renderer for AI replies.
// Used by AIAssistant + EmailHub chat (and anywhere else we need rich AI output).
export const mdComponents = {
  p: ({ node, ...props }) => <p className="mb-2 last:mb-0 leading-relaxed" {...props} />,
  h1: ({ node, ...props }) => (
    <h1 className="text-lg font-heading font-semibold mt-3 mb-2 text-foreground" {...props} />
  ),
  h2: ({ node, ...props }) => (
    <h2 className="text-base font-heading font-semibold mt-3 mb-2 text-foreground" {...props} />
  ),
  h3: ({ node, ...props }) => (
    <h3 className="text-sm font-heading font-semibold mt-2 mb-1 text-foreground" {...props} />
  ),
  ul: ({ node, ...props }) => <ul className="list-disc pl-5 mb-2 space-y-1" {...props} />,
  ol: ({ node, ...props }) => <ol className="list-decimal pl-5 mb-2 space-y-1" {...props} />,
  li: ({ node, ...props }) => <li className="leading-relaxed" {...props} />,
  strong: ({ node, ...props }) => (
    <strong className="font-semibold text-foreground" {...props} />
  ),
  em: ({ node, ...props }) => <em className="italic" {...props} />,
  a: ({ node, ...props }) => (
    <a
      className="text-primary underline underline-offset-2 hover:opacity-80"
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    />
  ),
  code: ({ node, inline, className, children, ...props }) =>
    inline ? (
      <code className="bg-muted px-1 py-0.5 rounded text-[0.85em] font-mono" {...props}>
        {children}
      </code>
    ) : (
      <pre className="bg-muted border rounded-md p-3 overflow-x-auto text-xs font-mono mb-2">
        <code {...props}>{children}</code>
      </pre>
    ),
  blockquote: ({ node, ...props }) => (
    <blockquote
      className="border-l-4 border-accent/50 pl-3 italic text-muted-foreground mb-2"
      {...props}
    />
  ),
  hr: () => <hr className="my-3 border-border" />,
  table: ({ node, ...props }) => (
    <div className="my-3 overflow-x-auto rounded-md border border-border">
      <table className="w-full border-collapse text-xs" {...props} />
    </div>
  ),
  thead: ({ node, ...props }) => (
    <thead className="bg-muted/70 text-foreground" {...props} />
  ),
  tbody: ({ node, ...props }) => <tbody className="divide-y divide-border" {...props} />,
  tr: ({ node, ...props }) => <tr className="hover:bg-muted/30" {...props} />,
  th: ({ node, ...props }) => (
    <th
      className="px-3 py-2 text-left font-semibold border-b border-border whitespace-nowrap"
      {...props}
    />
  ),
  td: ({ node, ...props }) => (
    <td className="px-3 py-2 align-top whitespace-normal break-words" {...props} />
  ),
};

export const MarkdownView = ({ children, className = '' }) => (
  <div className={`text-sm leading-relaxed ${className}`}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={mdComponents}>
      {children || ''}
    </ReactMarkdown>
  </div>
);

export default MarkdownView;
